import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { compose, withHandlers, withProps } from 'recompose';
import { filterType } from '../../../constants';
import { noCapMap } from '../../../utils';
import FormField from '../form-field';
import Icon from '../icon';

const PublisherFilter = ({
  handlePublisherFilterChange,
  filterPublishers,
  toggleFilterByPublisher,
  filterByPublisher
}) => (
    filterPublishers.length > 1 ?
      <div className='publisher-filter'>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h2 className='flexbox justify-between' type='button' onClick={toggleFilterByPublisher} aria-expanded={filterByPublisher} aria-controls='publisher-filter'>Filter by publisher <Icon icon='minus-large'></Icon></h2>
          </Col>
        </Row>
        <Collapse id="publisher-filter" in={filterByPublisher}>
          <form noValidate>
            <fieldset>
              <FormField id='publisher-name' label='Publisher' type='select-item'>
                <select
                  id='publisher-name'
                  required
                  onChange={(e) => handlePublisherFilterChange(e)}>
                  <option value={undefined}></option>
                  {
                    fp.compose(
                      fp.map(({ index, name }) => <option value={index} key={index}>{he.decode(name)}</option>),
                      fp.sortBy(({ name }) => fp.lowerCase(name))
                    )(filterPublishers)
                  }
                </select>
              </FormField>
            </fieldset>
          </form>
        </Collapse>
      </div> : null
  )

export default compose(
  withProps(({ business, publishers }) => ({
    filterPublishers: fp.flow(
      noCapMap((publisher, index) => ({
        id: publisher.id,
        name: publisher.name,
        type: filterType.Publisher,
        index: business ? index + 1 : index
      })),
      business ? fp.concat({
        id: business.id,
        name: business.name,
        type: filterType.Business,
        index: 0
      }) : fp.identity
    )(publishers)
  })),
  withHandlers({
    handlePublisherFilterChange: ({ filterPublishers, updateSelectedPublisherFilter }) => (e) => {
      const selectedFilter = fp.find(({ index }) => index.toString() === e.target.value)(filterPublishers);

      const selectedPublisher = fp.get('type')(selectedFilter) === filterType.Publisher ? fp.get('id')(selectedFilter) : undefined;
      const selectedBusiness = fp.get('type')(selectedFilter) === filterType.Business ? fp.get('id')(selectedFilter) : undefined;

      updateSelectedPublisherFilter(selectedPublisher, selectedBusiness);
    }
  })
)(PublisherFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/publisher-filter.js